module.exports = '<svg width="53" height="32" viewBox="0 0 53 32"><path d="M52.544 8.197a2.488 2.488 0 0 0 0-3.648L48.72.906c-1.051-1.013-2.763-1.013-3.813 0L26.752 18.479 8.437.762C7.376-.246 5.664-.246 4.613.762L.789 4.405a2.504 2.504 0 0 0 0 3.648l24.043 23.2c1.061 1.003 2.773 1.003 3.824 0L52.544 8.197z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-2.js
// module id = 1105
// module chunks = 14